import request from "@/utils/request";
// 退出方法
export function logout() {
  return request({
    url: "/logout",
    method: "post",
  });
}
// 修改密码
export function change_password(data) {
    return request({
        url: "/change_password",
        method: "post",
        data: data,
    });
}

// 登录
export function login(username, password) {
  const data = {
    username,
    password
  };
  return request({
    url: "/login",
    method: "post",
    data: data,
  });
}
